module.exports = __webpack_public_path__ + "static/media/Plogo.e05eeb48.svg";